import { render, staticRenderFns } from "./AlipayPayConfig.vue?vue&type=template&id=14468658&scoped=true"
import script from "./AlipayPayConfig.vue?vue&type=script&lang=js"
export * from "./AlipayPayConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14468658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14468658')) {
      api.createRecord('14468658', component.options)
    } else {
      api.reload('14468658', component.options)
    }
    module.hot.accept("./AlipayPayConfig.vue?vue&type=template&id=14468658&scoped=true", function () {
      api.rerender('14468658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mchApp/custom/AlipayPayConfig.vue"
export default component.exports